import { render, staticRenderFns } from "./CompanyTreePlanting.vue?vue&type=template&id=2225988e&scoped=true&"
import script from "./CompanyTreePlanting.vue?vue&type=script&lang=js&"
export * from "./CompanyTreePlanting.vue?vue&type=script&lang=js&"
import style0 from "./CompanyTreePlanting.vue?vue&type=style&index=0&id=2225988e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2225988e",
  null
  
)

export default component.exports